
import headlightTypesMixin from '@/mixins/headlightTypesMixin'

export default {
  name: 'ProductDatasheet',
  mixins: [headlightTypesMixin],
  props: {
    filters: Array,
    specifications: Boolean,
  },
  data() {
    return {
      fields: [
        {
          key: 'name',
          tdClass: 'px-0 font-weight-bold td-300',
          sortable: false,
        },
        { key: 'value', tdClass: 'px-0', sortable: false },
      ],
    }
  },
}
